import autoCompleteLoader from './utils/autoComplete/autoCompleteLoader';
import { cookieService } from './services/cookie-service';
import { uspsService } from './services/usps-service';
import { appBarService } from './services/appbar-service';

import './baseAssets'
import './services/newsletter'
import { accountService } from './services/account-service';
import {PopupManager} from './utils/popupManager';
import {incrementVisitCounter} from "./visitCounter";

const isHomePage = $('.js_homepage-segments').length > 0;

$(document).ready(async () => {
    incrementVisitCounter();
    uspsService.setUspText();
    cookieService.cookieBarInit();
    uspsService.commonUspsSlider();
    appBarService.downloadAppBarInit();
    try {
        await accountService.initializeUser();
    } catch (error) {
        console.error('Failed to initialize user', error);
    }

    $('.js_account-control').click(accountService.accountControlOnClick);

    new autoCompleteLoader();

    if (isHomePage) {
        import('./homePageBuilder').then(module => {
            const { homePageBuilder } = module;
            homePageBuilder();
        });

        import('@/homepageSegmentLazyLoader').then(module => {
            const { HomepageSegmentLazyLoader } = module;
            HomepageSegmentLazyLoader();
        });
    }

    const comparePopEl = document.querySelector('.js_compare-pop');

    if (comparePopEl) {
        import('@/services/searchPages/compareSelect.js').then(module => {
            const { default: CompareSelect } = module;
            window.compareSelect = new CompareSelect(comparePopEl);
            window.compareSelect.init();
        });
    }

    const aiGuidePopup = new PopupManager({
        triggerSelector: '.js_ai-guide-chat-trigger',
        popupSelector: '.js_ai-guide-chat',
        backgroundSelector: '.js_ai-guide-chat-background',
        closeSelector: '.js_ai-guide-chat-close',
        focusOnOpenSelector: '.js_ai-guide-chat-close',

        onOpen: () => {
            aiGuidePopup.refreshFocusTrap();
        }
    });
});
